import { Component, EventEmitter, Input, Output } from "@angular/core"
import { Observable } from "rxjs"

@Component({
    selector: "app-user-localization",
    templateUrl: "./user-localization.component.html",
    styleUrls: ["./user-localization.component.scss"],
})
export class UserLocalizationComponent {
    @Input()
    localizeData$: Observable<any>

    @Input()
    showStateStandards: boolean

    @Output()
    changeStation = new EventEmitter<string>()

    onChangeStationClick() {
        this.changeStation.emit()
    }
}
